import Swiper from 'swiper';
import { Mousewheel, Keyboard, Navigation, Pagination, Scrollbar, Autoplay, EffectCube, EffectFade, EffectCoverflow, EffectCreative, EffectFlip, EffectCards, FreeMode } from 'swiper/modules';
import AOS from 'aos';
import ko from 'knockout';

ko.bindingHandlers.swiper = {
    init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {

        var modelValue = valueAccessor(),
            unwrappedValue = ko.utils.peekObservable(modelValue);
        
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            element.swiper.destroy();
        });

        var init = true;

        ko.bindingEvent.subscribe(element, 'childrenComplete', () => {
            console.log("Init Swiper ", element);

            const options = Object.assign({
                modules: [Mousewheel, Keyboard, Navigation, Pagination, Scrollbar, Autoplay, EffectCube, EffectFade, EffectCoverflow, EffectCreative, EffectFlip, EffectCards, FreeMode],
                loop: true,

            }, unwrappedValue.options);

            if (unwrappedValue.index) {
                options.initialSlide = unwrappedValue.index();
            }

            const aosElements = element.querySelectorAll("[data-aos]");
            if (aosElements.length) {
                options.on = {
                    slideChangeTransitionStart: (x) => {
                        if (!init) { 
                            aosElements.forEach(el => {
                                el.style.display = 'none';
                                el.classList.remove('aos-init', 'aos-animate');
                            });
                        }
                    },
                    slideChangeTransitionEnd: () => {
                        if (!init) {
                            aosElements.forEach(el => {
                                el.style.display = null;
                            });

                            AOS.init();
                        }
                    }
                }
            }

            const swiper = new Swiper(element, options);

            if (unwrappedValue.index) {
                swiper.on("activeIndexChange", (swiper) => {
                    if (swiper.activeIndex != unwrappedValue.index()) {
                        unwrappedValue.index(swiper.activeIndex);
                    }
                });
            }

            //swiper.on("slideChange", () => {
            //    console.log("Active-Slide: " + swiper.activeIndex)
            //    var slide = swiper.slides[swiper.activeIndex];

            //    slide.classList.remove("bg-lazy");
            //});

            init = false;
        });

        return { 'controlsDescendantBindings': false };
    },
    update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
        const modelValue = valueAccessor(),
            unwrappedValue = ko.utils.peekObservable(modelValue);

        /* const data = unwrappedValue.data();*/
        if (unwrappedValue.index) {
            const index = unwrappedValue.index();

            const swiper = element.swiper;
            if (swiper) {
                element.swiper.update();

                if (swiper.activeIndex !== index) {
                    element.swiper.slideTo(index);
                }
            }
        }
    }
}